import type { QueryClient } from "@tanstack/react-query";
import {
	createRootRouteWithContext,
	HeadContent,
	Outlet,
} from "@tanstack/react-router";

import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Toaster } from "sonner";
import type { authClient } from "@/auth";

// const _TanStackDevtools = import.meta.env.DEV
// 	? lazy(() =>
// 			import("@tanstack/react-devtools").then((mod) => ({
// 				default: mod.TanStackDevtools,
// 			})),
// 		)
// 	: () => null;

// const _TanStackRouterDevtoolsPanel = import.meta.env.DEV
// 	? lazy(() =>
// 			import("@tanstack/react-router-devtools").then((mod) => ({
// 				default: mod.TanStackRouterDevtoolsPanel,
// 			})),
// 		)
// 	: () => null;

// const _ReactQueryDevtoolsPanel = import.meta.env.DEV
// 	? lazy(() =>
// 			import("@tanstack/react-query-devtools").then((mod) => ({
// 				default: mod.ReactQueryDevtoolsPanel,
// 			})),
// 		)
// 	: () => null;

interface RouterContext {
	queryClient: QueryClient;
	authSession: ReturnType<typeof authClient.useSession>["data"];
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: RootComponent,
});

function RootComponent() {
	return (
		<SkeletonTheme
			baseColor="var(--color-base-300)"
			highlightColor="var(--color-base-200)"
		>
			<HeadContent />
			<Outlet />
			<Toaster />
			{/* <Suspense>
				<TanStackDevtools
					config={{
						position: "top-right",
					}}
					plugins={[
						{
							name: "Tanstack Router",
							render: <TanStackRouterDevtoolsPanel />,
						},
						{
							name: "Tanstack Query",
							render: <ReactQueryDevtoolsPanel />,
						},
					]}
				/>
			</Suspense> */}
		</SkeletonTheme>
	);
}
